import { ArchiveSearchIcon } from './ArchiveSearchIcon';

/**
 * author: Colton Wiscombe
 * id 28C866C2-139E-4AF4-8E3D-F23CFE556B59
 * name archive-search
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-search.svg
 * tags
 */
export const BoxSearchIcon = ArchiveSearchIcon;
export default BoxSearchIcon